import {isSafari} from '@exadel/esl/modules/esl-utils/environment';
import {isElement} from '@exadel/esl/modules/esl-utils/dom';
import {ESLMediaQuery} from '@exadel/esl/modules/esl-media-query/core';

// For compatibility
export {reverseTheme, setHeaderTheme} from 'core/helpers/themes';

export function isSNEnabled(): boolean {
  return !!document.querySelector('gn-header')?.hasAttribute('has-secondary');
}

export function getStickyHeaderHeight() {
  if (ESLMediaQuery.for('@-MD').matches) return 0;
  const header = document.querySelector<HTMLElement>('gn-header[sticky]');
  if (!header) return 0;
  // As secondary nav should stick without primary nav
  const target = isSNEnabled() ? header.querySelector<HTMLElement>('.gn-nav-secondary') : header;
  return target.offsetHeight;
}

/** Helper to properly animate GN logo */
export function animateLogo($logo: Element) {
  if (!isElement($logo) || $logo.classList.contains('play')) return;
  const useSmil = !$logo.classList.contains('css-animation') || isSafari;
  if (useSmil) $logo.classList.remove('css-animation');
  setTimeout(() => {
    $logo.classList.add('play');
    // Hook in case of hotfix
    if (!$logo.dispatchEvent(new Event('gn:logo:animate', {cancelable: true, bubbles: false}))) return;
    if (!useSmil) return;
    [...$logo.querySelectorAll('animate[begin*="indefinite"]')]
      .forEach((anim: SVGAnimationElement) => anim?.beginElement());
  }, 10); // Push to macro-task query
}
